import { useState } from 'react';

import { Box, IconButton, Badge } from '@mui/material';

import NotificationsIcon from 'components/common/icons/Notification';

import useSettings, { IWebsiteConfigs } from 'store/settings';
import useNotifications from 'store/notifications';
import useMount from 'hooks/useMount';
import NotificationMenu from './NotificationMenu';

const Notifications = () => {
  const [notificationsState, notificationsActions] = useNotifications();
  const [anchorEl, setAnchorEl] = useState(null);
  const [
    {
      data: { meta = {} as IWebsiteConfigs },
    },
  ] = useSettings();

  const isNotificationOpen = Boolean(anchorEl);

  const handleNotificationOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setAnchorEl(null);
  };

  useMount(() => {
    notificationsActions.getUnreadCount();
  });

  if (!meta.showNotifications) return null;

  return (
    <Box>
      <IconButton color="inherit" onClick={handleNotificationOpen}>
        {notificationsState.unreadCount ? (
          <Badge
            color="error"
            badgeContent={Math.max(notificationsState.unreadCount || 0)}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <NotificationsIcon />
          </Badge>
        ) : (
          <NotificationsIcon />
        )}
      </IconButton>
      {isNotificationOpen && <NotificationMenu anchorEl={anchorEl} onClose={handleNotificationClose} />}
    </Box>
  );
};

export default Notifications;
